(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.controller('HelpCategoryController', ['$uibModalInstance', 'helpcategory', HelpCategoryControllerFn]);

    /* HelpCategory Controller */
    function HelpCategoryControllerFn($uibModalInstance, helpcategory) {
        var vm = this;

        // cancel modal
        vm.cancel = function () {
            $uibModalInstance.dismiss("abort");
        };
    }
})();
